export var defaultProps = {
    className: '',
    active: false,
    loading: undefined,
    avatar: false,
    paragraph: true,
    title: false,
};
export var defaultButtonProps = {
    shape: 'default',
    active: false,
};
export var defaultInputProps = {
    shape: 'default',
    active: false,
};
export var defaultImageProps = {
    active: false,
};
